import { render, staticRenderFns } from "./goldDetail.vue?vue&type=template&id=27c0e6a5"
import script from "./goldDetail.vue?vue&type=script&lang=js"
export * from "./goldDetail.vue?vue&type=script&lang=js"
import style0 from "./goldDetail.vue?vue&type=style&index=0&id=27c0e6a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports